import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    loadTokens
} from "../store/interactions";

import config from "../config.json";
import { useEffect } from "react";

import Select from 'react-select';
import React, { CSSProperties } from 'react';



const Markets = ()=>{
    const provider = useSelector(state => state.provider.connection);
    const chainId = useSelector(state => state.provider.chainId);
    const dispatch = useDispatch();

    const symbols = useSelector(state => state.tokens.symbols);

    const marketHandler = (event)=>{
         if(dispatch && provider && event)  loadTokens(dispatch,provider,(event.target.value).split(','));
    }



    const customStyles = {
        control: (provided, state) => ({
          ...provided,
          border: state.isFocused ? '2px solid #4a90e2' : '2px solid #ccc',
          borderRadius: '8px',
          boxShadow: state.isFocused ? '0 0 0 2px #4a90e2' : 'none',
          '&:hover': {
            border: '2px solid #4a90e2',
          },
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? '#4a90e2' : 'white',
          color: state.isFocused ? 'white' : 'black',
          '&:hover': {
            backgroundColor: '#4a90e2',
            color: 'white',
          },
        }),
        menu: (provided, state) => ({
          ...provided,
          backgroundColor: '#fff',
          border: '2px solid #4a90e2',
          borderRadius: '8px',
        }),
      };



      const options = [
        { 
            value: `${config[chainId]?.WETH?.address},${config[chainId]?.tUSDT?.address}`, 
            label: (
                config[chainId]?.WETH && config[chainId]?.tUSDT && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].WETH.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDT.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>WETH / tUSDT</span>
                    </div>
                )
            ) 
        },
        { 
            value: `${config[chainId]?.WETH?.address},${config[chainId]?.tUSDC?.address}`, 
            label: (
                config[chainId]?.WETH && config[chainId]?.tUSDC && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].WETH.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDC.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>WETH / tUSDC</span>
                    </div>
                )
            ) 
        },
        { 
            value: `${config[chainId]?.tTokenA?.address},${config[chainId]?.tUSDT?.address}`, 
            label: (
                config[chainId]?.tTokenA && config[chainId]?.tUSDT && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].tTokenA.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDT.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>tTokenA / tUSDT</span>
                    </div>
                )
            ) 
        },
        { 
            value: `${config[chainId]?.tTokenA?.address},${config[chainId]?.tUSDC?.address}`, 
            label: (
                config[chainId]?.tTokenA && config[chainId]?.tUSDC && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].tTokenA.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDC.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>tTokenA / tUSDC</span>
                    </div>
                )
            ) 
        },
        { 
            value: `${config[chainId]?.tTokenB?.address},${config[chainId]?.tUSDT?.address}`, 
            label: (
                config[chainId]?.tTokenB && config[chainId]?.tUSDT && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].tTokenB.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDT.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>tTokenB / tUSDT</span>
                    </div>
                )
            ) 
        },
        { 
            value: `${config[chainId]?.tTokenB?.address},${config[chainId]?.tUSDC?.address}`, 
            label: (
                config[chainId]?.tTokenB && config[chainId]?.tUSDC && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].tTokenB.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDC.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>tTokenB / tUSDC</span>
                    </div>
                )
            ) 
        },
        { 
            value: `${config[chainId]?.tTokenDrop?.address},${config[chainId]?.tUSDT?.address}`, 
            label: (
                config[chainId]?.tTokenDrop && config[chainId]?.tUSDT && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={config[chainId].tTokenDrop.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
                        <img src={config[chainId].tUSDT.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
                        &nbsp;
                        <span>tTokenDrop / tUSDT</span>
                    </div>
                )
            ) 
        },


        // { 
        //     value: `${config[chainId]?.tTokenDrop?.address},${config[chainId]?.tUSDC?.address}`, 
        //     label: (
        //         config[chainId]?.tTokenDrop && config[chainId]?.tUSDC && (
        //             <div style={{ display: 'flex', alignItems: 'center' }}>
        //                 <img src={config[chainId].tTokenDrop.image} style={{ width: '32px', marginRight: '4px', zIndex: 2 }}/>
        //                 <img src={config[chainId].tUSDC.image} style={{ width: '24px', marginLeft: '-16px', position: 'relative', top: '-50%', zIndex: 1 }}/>
        //                 &nbsp;
        //                 <span>tTokenDrop / tUSDC</span>
        //             </div>
        //         )
        //     ) 
        // },

        
    ];
    
    const filteredOptions = options.filter(option => option.label);
      


    return(

    <div className="component exchange__markets">
    <div className="component__header" style={{ display: 'flex', alignItems: 'center' }}>
        
        <h2 style={{ marginRight: '10px' }}> Select: Trade/Pairs</h2> 
        <br></br><br></br><br></br>
        <div className="token-logos">
            <img 
                src={config && chainId && symbols && symbols[0] && config[chainId][symbols[0]] ? config[chainId][symbols[0]]['image'] : ''} 
                className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
                alt="TokenLogo"
            />/
            <img 
                src={config && chainId && symbols && symbols[1] && config[chainId][symbols[1]] ? config[chainId][symbols[1]]['image'] : ''} 
                className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
                alt="TokenLogo"
            />
        </div>
    </div>
        
    {
    chainId && config[chainId] ? (
<Select 
    options={filteredOptions}
    styles={customStyles} 
    onChange={(selectedOption) => {
        if (dispatch && provider && selectedOption) {
            loadTokens(dispatch, provider, selectedOption.value.split(','));
        }
    }}
/>


        
    ) : (
        <div className="flex-center animate-pulse text-red-500">
            {/* <p>Not deployed to network</p> */}
            <a href="https://open-dex.gitbook.io/docs-willow/reference/testnet/network" target="_blank" className=""> 
            <p>Not supported this network yet!! &nbsp;  
            </p>
            </a>
        </div>
    )
}
            
            <hr />


        </div>
    );
}

export default Markets;